module.exports = __webpack_public_path__ + "2670db57b5539d9228fbabab85c04892.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IO.svg
// module id = B+wl
// module chunks = 0